import React, {Component} from 'react'
import {Form, Select,message, Row, Col, Input, DatePicker, Button, Table,Modal} from 'antd';
import './newsActivityIndex.css';
import {uuid, formatDate, permissionCheck, applicationName} from "../../utils";
import {
    getNewActivityDataList,
    deleteInterview,
    publishNewActivity,
    getById,
    getNewActivityWeekDayInfo, getByClueId
} from "../../actions/newsActivityAction";
import StepPopupBox from "../../components/StepPopupBox";
import NewActivityBaseInfo from "./NewActivityBaseInfo";
import PlansToplatform from "./PlansToplatform";
import NewsActivitySelectReporter from "./NewsActivitySelectReporter";
import NewsActivityComplete from "./NewsActivityComplete";
import TabModal from "../../components/TabModal";
import NewsActivityBaseInfo, {
    NewsActivityBaseInfoFooter
} from "../../components/interview/NewsActivityBaseInfo";
import NewsActivityPublishPlatform from "../../components/interview/NewsActivityPublishPlatform";
import NewsActivityReporter from "../../components/interview/NewsActivityReporter";
import NewsActivityWriteStory from "../../components/interview/NewsActivityWriteStory";
import NewsActivityPicture from "../../components/interview/NewsActivityPicture";
import NewsActivityVideo from "../../components/interview/NewsActivityVideo";
import NewsActivityArtFile from "../../components/interview/NewsActivityArtFile";
import {getNewsActivityById, takeTask} from "../../actions/interview";
import {connect} from "react-redux";
import {getTopicSelectionById} from "../../actions/topicSelection";
import {getProjectById} from "../../actions/majorProjects";
import {HEADER_HEIGHT} from "../../constants";
import eventProxy from "../../utils/eventProxy";
import {getNewsclueById} from "../../actions/newsClue";
import moment from 'moment';

const {RangePicker } = DatePicker;

/***
 * 任务首页
 */
const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal;

// 活动
const TYPE_ACTIVITY = 1;
// 选题
const TYPE_TOPIC = 2;
export const haveEditAuthRoleCode = "zb";//可以进行增加或者修改任务的角色,目前是总编

let newActivityBaseInfoKey = uuid();
let plansToplatformKey = uuid();
let newsActivitySelectReporterKey = uuid();

class NewsActivityIndex extends Component{

    defaultStep = 0;

    constructor(props){
        super(props);
        this.state={
            stepCurrent:this.defaultStep,
            stepVisible:false,
            newsActivityViewVisible: false,
            newsActivityViewActiveIndex: 0,
            newsActivity:{},
            activityCountData:[{title:"今日下发",count:0},{title:"今日完成",count:0},{title:"本周下发",count:0},{title:"本周完成",count:0}],
            newsActivityStatusData:[{key:'all',value:"全部"},{key:'unget',value:"未领取"},{key:'overTime',value:"已超期"},
                {key:'doing',value:"进行中"},{key:'submitted',value:"已提交"},{key:'completed',value:"已完成"}],
            columns: [
                {
                    key:'1',
                    title: 'type',
                    dataIndex: 'type',
                    width: '4%',
                    render:(value, row, index)=>{
                        return <div className={"activity_type"}>
                            <img src={'images/newsactivity/newactivity_flag.png'} width={'53px'}/>
                           </div>
                    }
                },
                {
                    key:'2',
                    title: 'title',
                    dataIndex: 'title',
                    width: '44%',
                    render:(value, row)=>{
                        return <div style={{cursor:"pointer"}} onClick={()=>{
                            this.viewNewActivity(row);
                        }}>{this.renderTitle(row)}</div>
                    }
                },
                {
                    key:'3',
                    title: '位置',
                    dataIndex: 'place',
                    width: '10%',
                    render:(value, row, index)=>{
                        return <div style={{color: '#8792b3',fontSize:'15px',fontWeight:"bold"}}>
                            <img width={'18px'} src={'images/newsactivity/position.png'}/><span style={{marginLeft:'10px'}}>{value?value:"未设置"}</span></div>
                    }
                },
                {
                    key:'4',
                    title: '活动时间',
                    dataIndex: 'interviewDate',
                    width: '15%',
                    render:(value, row, index)=>{
                        return <div style={{color: '#8792b3',fontSize:'15px',fontWeight:"bold"}}>
                            <img width={'18px'} src={'images/newsactivity/newsactivity_time.png'}/>
                            <span style={{marginLeft:'10px'}}>{value?formatDate(value.time):"未设置"}</span></div>;
                    }
                },
                {
                    key:'5',
                    title: '状态',
                    dataIndex: 'status',
                    width: '10%',
                    render:(value, row, index)=>{
                        return this.formateStatus(value,row);
                    }
                },
                {
                    key:'6',
                    title: '操作',
                    width:'7%',
                    render: (value, row, index) => (()=>{
                        let isOpAuth = permissionCheck("pms:newsActiviti:edit");

                        let isEditAuth = (row.status !== 4);//已发布
                        let isDeleteAuth = (row.status === 1);//如果是未领取则可以删除

                        let activityTime;//活动时间
                        if(row.endDate){
                            activityTime=row.endDate.time;
                        }else{
                            activityTime=row.interviewEndDate?row.interviewEndDate.time:0;//活动时间
                        }

                        let nowDate=new Date().getTime();//当前时间
                        let statusName;
                        if(row.status===1&&activityTime&&activityTime<nowDate){
                            statusName='已超期'
                        }
                        return <div style={{color:'#576184',fontFamily: 'MicrosoftYaHei-Bold',
                            fontSize: '15px',fontWeight: 'bold'}}>
                            {(isOpAuth&&isEditAuth&&(statusName!=='已超期'))?<a className={'operation_button'} onClick={()=>{
                                this.updateData(row)
                            }}>修改</a>:""}
                            {isDeleteAuth&&permissionCheck("pms:newsActiviti:delete")?
                                <a className={'operation_button'} onClick={()=>{this.deleteData(row)}}>删除</a>:""}
                        </div>
                    })()
                },
            ],
            newActivityTableData:{},
            activityUrl:"/cm-sites-" + applicationName() + "/interview/all",
            currentPage:1,
            startDate:'',
            endDate:'',
            searchValue:'',
            newsActivityViewTabs:[],
            newsActivityViewTabPanels:[],
            taskStatus:1,
            selectValue:'全部'
        };
        this.sendPlatformRef=React.createRef();
        this.activityCompleteRef=React.createRef();
    }

    isLoadList = false;//当创建了或者修改了如果关闭掉弹窗的时候，就应该刷新列表

    /**
     * 修改数据
     * @param data
     */
    updateData(data){
        let taskStatus=1;
        this.updateDataById(data.id);
        this.setState({
            taskStatus
        })
    }

    updateDataById(id){

        window.loading.show();
        getById(id).then(newsActivity=>{

            console.log('newsActivity',newsActivity)
            if(newsActivity.interviewDate){
                newsActivity.interviewDate = new Date(newsActivity.interviewDate.time);
            }
            if(newsActivity.endDate){
                newsActivity.endDate = new Date(newsActivity.endDate.time);
            }

            this.setState({
                stepVisible:true,
                newsActivityViewVisible:false,
                newsActivity
            });
            window.loading.hide();
        });
        newActivityBaseInfoKey = uuid();
        plansToplatformKey = uuid();
        newsActivitySelectReporterKey = uuid();
        // message.info("修改数据"+JSON.stringify(data),1);
    }

    /**
     * 任务页面，标题列的渲染。
     * @param record
     */
    renderTitle(record){
        return <div className={"row_title"}>
            <div className={"record_title"}>{record.title}</div>
            <div className={"record_content"}>{record.content}</div>
        </div>
    }

    /**
     * 删除数据
     * @param data
     */
    deleteData(data) {
        let that = this;

        confirm({
            className:'delete_dialog',
            title: '提示',
            content: '确定删除此任务？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                let param = {
                    id: data.id,
                }
                deleteInterview(param, function (res) {
                    if (res.status == '-1') {
                        message.error(res.msg, 1);
                    } else {
                        message.success(res.msg, 1, () => {
                            that.getFirstPageData()
                        });
                    }
                })
            },
            onCancel() {

            },
        });

    }

    /**
     * 格式化，状态。
     * @param value
     */
    formateStatus(value,row){

        let activityTime;//活动时间
        if(row.endDate){
            activityTime=row.endDate.time;
        }else{
            activityTime=row.interviewEndDate?row.interviewEndDate.time:0;//活动时间
        }
        let nowDate=new Date().getTime();//当前时间
         if(value==1){
             let statusName = "未领取";
             if(activityTime){
                 statusName=activityTime<nowDate?'已超期':'未领取';
             }
             if(statusName==='未领取'){
                 return <div className={"unget_status"}>{statusName}</div>
             }else{
                 return <div className={"overdue"}>{statusName}</div>
             }

         }else if(value==2){
             return <div className={"recieve_status"}>进行中</div>
         }else if(value==3){
             return <div className={"submitted_status"}>已提交</div>
         }else if(value==4){
             return <div className={"publish_status"}>已完成</div>
         }
    }

    //点击下拉框事件
    handleChange(value) {
        this.state.selectValue=value;
        switch (value) {
            case "all":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/all";
                break;
            case "unget":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/notGetList";
                break;
            case "overTime":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/timeoutList";
                break;
            case "doing":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/getList";
                break;
            case "submitted":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/overList";
                break;
            case "completed":
                this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/completeList";
                break;
        };
        window.loading.show();
         this.getFirstPageData(()=>{window.loading.hide()});
    }
    
    componentDidMount() {
        let that = this;
        console.log(that)
        eventProxy.on('addTask',(interviewEventId) => {
            if(interviewEventId){
                     getProjectById(interviewEventId).then(dto=>{
                        //  that.setState({
                        //     stepVisible: true,
                        //     newsActivity: { eventItem:[dto] },
                        //     stepCurrent:that.defaultStep
                        // })
                        this.setState({
                            stepVisible: true,
                            taskStatus:0,
                            newsActivity: { eventItem:[dto] },
                             stepCurrent:that.defaultStep
                         })
                         newActivityBaseInfoKey = uuid();
                         plansToplatformKey = uuid();
                         newsActivitySelectReporterKey = uuid();  
                    })
            }
        })
        eventProxy.on('seeTask',(interviewId) => {
            if(interviewId){
                this.viewNewActivityById(interviewId);
            }
        })
        eventProxy.on('editTask',(interviewId) => {
            if(interviewId){
                this.updateDataById(interviewId);
            }
        })
        getNewActivityWeekDayInfo({interviewType:1},(data)=>{
            if(data){
                let activityCountData = [{title: "今日下发", count: data.data.dayCreate}, {title: "今日完成", count:  data.data.dayComplete}, {
                    title: "本周下发",
                    count:  data.data.weekCreate
                }, {title: "本周完成", count:  data.data.weekComplete}];
                this.setState({
                    activityCountData
                })
            }
        });
        window.loading.show();
        this.getFirstPageData(()=>{window.loading.hide()});
        eventProxy.on('newsClueAdd',(clueId) => {
            if (clueId) {
                getNewsclueById(clueId).then(data => {
                    this.setState(prevState => {
                        if(!data.resourceIds){
                            data.resourceIds = [];
                        }
                        if(!data.attachmentResourceIds){
                            data.attachmentResourceIds = [];
                        }
                        return {
                            stepVisible: true,
                            taskStatus:0,
                            newsActivity: {
                                title: data.title,
                                content: data.content,
                                contacts: data.contacts,
                                contactsWay: data.contactsWay,
                                attachmentResourceIds: [...data.resourceIds, ...data.attachmentResourceIds],
                                clueId
                            },
                            stepCurrent: this.defaultStep
                        }
                    });
                    newActivityBaseInfoKey = uuid();
                    plansToplatformKey = uuid();
                    newsActivitySelectReporterKey = uuid();
                });
            }
        })
        eventProxy.on('newsClueView',(clueId) => {
            console.log(333)
            window.loading.show();
            getByClueId(clueId).then(dto=>{
                let {data,status,msg} = dto;
                let newsActivity = JSON.parse(data);
                if(status===-1 && msg){
                    message.error(msg);
                    window.loading.hide();
                    return;
                }
                window.loading.hide();
                let {newsActivityViewTabs,newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(newsActivity);
                this.setState({
                    stepVisible:false,
                    newsActivityViewVisible:true,
                    newsActivityViewTabs,newsActivityViewTabPanels,
                    newsActivity
                });
            });
        })
        eventProxy.on('add',(topicSelectionId) => {
            let operation = "add";
            if (operation && topicSelectionId) {
                if (topicSelectionId) {
                    if (operation === "add") {//view查看任务  //add新增任务
                        getTopicSelectionById(topicSelectionId).then(dto => {
                            this.setState(prevState => {
                                return {
                                    stepVisible: true,
                                    taskStatus:0,
                                    newsActivity: {
                                        title: dto.data.tsName,
                                        attachmentResourceIds: dto.data.tsFileIds,
                                        content: dto.data.tsContent,
                                        contacts: dto.data.tsContactsName,
                                        contactsWay: dto.data.tsContactsPhone,
                                        sponsor: dto.data.tsCompany,
                                        topicSelectionId
                                    },
                                    stepCurrent: this.defaultStep
                                }
                            });
                            newActivityBaseInfoKey = uuid();
                            plansToplatformKey = uuid();
                            newsActivitySelectReporterKey = uuid();
                        });
                    }
                }
            }
        })
        eventProxy.on('view',(topicSelectionId) => {

            let operation="view";
            if(operation === "view"){
                getTopicSelectionById(topicSelectionId).then(dto=>{
                    window.loading.show();
                    getNewsActivityById(dto.data.tsTaskId, (newsActivity)=>{
                        window.loading.hide();
                        let {newsActivityViewTabs,newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(newsActivity);
                        this.setState({
                            stepVisible:false,
                            newsActivityViewVisible:true,
                            newsActivityViewTabs,newsActivityViewTabPanels,
                            newsActivity
                        });
                    });
                });
            }
        })

    }

    componentWillUnmount = () => {
        // 清除监听
        eventProxy.off('addTask', '');
        eventProxy.off('seeTask', '');
        eventProxy.off('editTask', '');
        eventProxy.off('add', '');
        eventProxy.off('view', '');
        eventProxy.off('newsClueAdd', '');
        eventProxy.off('newsClueView', '');
  };

    /**
     * 获取第一页的数据；
     */
    getFirstPageData(callBack){
        let formData={
            "start":1,
            "size":10,
            "interviewType":1,
            "currentTime":new Date().getMilliseconds(),
        }

        //加入，时间的过滤；
        if(this.state.startDate){
            formData['startDate']  =this.state.startDate;
        }

        if(this.state.endDate){
            formData['endDate']  =this.state.endDate;
        }
        if(this.state.searchValue){
            formData['queryStr']  =this.state.searchValue;
        }
        let url=this.state.activityUrl;
        this.state.currentPage=1;
        getNewActivityDataList(url,formData, (data)=>{
            this.updateNewActivityListData(data);
            if(callBack){
                callBack();
            }
        });
    }

    viewNewActivity = (row)=>{
        this.viewNewActivityById(row.id);
    };

    viewNewActivityById = (id)=>{
        window.loading.show();
       console.log('----------------')
        getNewsActivityById(id, (newsActivity)=>{
            console.log(newsActivity)
            window.loading.hide();
            let {newsActivityViewTabs,newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(newsActivity);
            if(newsActivity.interviewJointers && newsActivity.interviewJointers.length){
                newsActivity.interviewJointers.forEach((item,index)=>{
                    if(item.status === 3){
                        item.status = 2
                    }
                })
            }
            this.setState({
                stepVisible:false,
                newsActivityViewVisible:true,
                newsActivityViewActiveIndex:0,
                newsActivityViewTabs,newsActivityViewTabPanels,
                newsActivity
            });
        });
    };

    updateNewActivityListData(data){
        if(data){
            this.setState({
                newActivityTableData:data,
            })
        }
    }

    //点击分页事件。
    onTableChange(pagination){
        let formData={
            "start":pagination.current,
            "size":pagination.pageSize,
            "interviewType":1,
            "currentTime":new Date().getMilliseconds(),
        }

        if(this.state.startDate){
            formData['startDate']  =this.state.startDate;
        }

        if(this.state.endDate){
            formData['endDate']  =this.state.endDate;
        }


        this.state.currentPage=pagination.current;
        let url=this.state.activityUrl;
        getNewActivityDataList(url,formData,this.updateNewActivityListData.bind(this))
    }

    //添加活动
    addNewActivity(){
        let taskStatus=0;
        this.setState({
            stepVisible:true,
            newsActivity:{},
            stepCurrent:this.defaultStep,
            taskStatus
        });
        newActivityBaseInfoKey = uuid();
        plansToplatformKey = uuid();
        newsActivitySelectReporterKey = uuid();
    }

    saveBaseInfo(){
        //获取基本信息数据，并且校验。
        let errorsInfo=[];
        this.activityBaseForm.props.form.validateFields((errors,values)=>{
            errorsInfo=errors;
        });

        if(errorsInfo){
            for(let i in errorsInfo){
                message.error(errorsInfo[i].errors[0].message,1);
                return false;
            }
        }
        let actiBaseInfo=this.activityBaseForm.props.form.getFieldsValue();

        let attachmentResourceIds = [];
        for(let i = 0 ; this.activityBaseForm.state.fileList && i < this.activityBaseForm.state.fileList.length; i++){
            let file = this.activityBaseForm.state.fileList[i];
            if(file.resourceId){
                attachmentResourceIds.push(file.resourceId);
            }
        }

        let _itemIds = [];

        this.state.newsActivity.eventItem && this.state.newsActivity.eventItem.map(item=>{
            _itemIds.push(item.id);
        });

        if(actiBaseInfo.leixing !== "选题策划"){
            if(!this.activityBaseForm.state.interviewDate){
                message.error("请选择活动时间");
                return false;
            }
        }

        let newsActivity={...this.state.newsActivity, ...actiBaseInfo, interviewType:TYPE_ACTIVITY, attachmentResourceIds, sponsor:this.activityBaseForm.state.sponsor};
        if(parseInt(newsActivity.status) !== 2 && (parseInt(newsActivity.status)!==3) && (parseInt(newsActivity.status)!==4)){//已领取  已提交 已发布只要是这些状态就不能改变状态
            newsActivity.status = 1;//1为未领取
        }
        newsActivity.type = 0;//0 普通任务 1 组图任务(广外的)
        // newsActivity.interviewDate = this.activityBaseForm.state.interviewDate.toDate();
        // newsActivity.endDate = this.activityBaseForm.state.endDate?this.activityBaseForm.state.endDate.toDate():undefined;
        newsActivity.eventItem = this.activityBaseForm.state._items;//用于回显
        if(newsActivity.endDate && newsActivity.interviewDate >= newsActivity.endDate){
            message.error("活动时间必须早于回稿时间");
            return false;
        }

        if(newsActivity.title && newsActivity.title.length > 100){
            message.error("名称过长，请勿超过100字");
            return false;
        }
        if(newsActivity.content && newsActivity.content.length > 1000){
            message.error("内容过长，请勿超过1000字");
            return false;
        }

        // let regex = new RegExp("^(((4|8)[0]{2}-\\d{7})|(0\\d{2,3}-\\d{7,8})|(1\\d{10}))$");
        // if(newsActivity.contactsWay){
        //     let contactsWayIsError = !regex.test(newsActivity.contactsWay);
        //     if(contactsWayIsError){
        //         message.error("联系方式格式错误，请检查");
        //         return false;
        //     }
        // }

        newsActivity._itemIds = _itemIds.join(",");

        if(!this.props.sysConfig){
            message.error("检测网络卡顿，系统配置未初始化完成！请刷新页面重新提交。");
            return false;
        }
        if(newsActivity.interviewDate){
            let inerviewDateAfter = this.props.sysConfig.getValueByKey("new.activity.inerviewDate.after", "24 * 60 * 60 * 1000");
            let interviewEndDate = new Date(newsActivity.interviewDate.getTime() + eval(inerviewDateAfter));
            newsActivity.interviewEndDate = interviewEndDate;
        }
        this.setState({
            newsActivity,
        });
        return true;
    }

    saveToplatform(){

        let selectMedias=this.sendPlatformRef.state.checkedDataData;
        let mediaIds=[];
        if(selectMedias && selectMedias.length>0){
            for(let i=0;i < selectMedias.length;i++){
                mediaIds.push(selectMedias[i].id);
            }
        }
        if(mediaIds.length === 0 ){
            message.error("请至少选择一个拟发平台");
            return false
        }
        let newsActivity = {...this.state.newsActivity, mediaIds};
        this.setState({
            newsActivity,
        });
        return true;
    }

    saveSelectReporter = ()=>{
        let interviewJointers = this.selectReporterRef.state.interviewJointers;
        if(!interviewJointers || (interviewJointers.length === 0) ){
            message.error("请至少分派一个记者");
            return false;
        }

        let params = {
            id:this.state.newsActivity.id?this.state.newsActivity.id:0,
            title: this.state.newsActivity.title,
            interviewDate:this.state.newsActivity.interviewDate ? this.state.newsActivity.interviewDate: undefined,
            place:this.state.newsActivity.place,
            endDate:this.state.newsActivity.endDate ? this.state.newsActivity.endDate: undefined,
            contacts:this.state.newsActivity.contacts,
            contactsWay:this.state.newsActivity.contactsWay,
            content:this.state.newsActivity.content,
            interviewType:this.state.newsActivity.interviewType,
            leixing:this.state.newsActivity.leixing,
            attachmentResourceIds:this.state.newsActivity.attachmentResourceIds,
            status:this.state.newsActivity.status,
            type:this.state.newsActivity.type,
            interviewEndDate:this.state.newsActivity.interviewEndDate ? this.state.newsActivity.interviewEndDate: undefined,
            mediaIds:this.state.newsActivity.mediaIds,
            sponsor:this.state.newsActivity.sponsor,
            _itemIds:this.state.newsActivity._itemIds,
            storyIds:this.state.newsActivity.storyIds?this.state.newsActivity.storyIds:[],
            clueId:this.state.newsActivity.clueId?this.state.newsActivity.clueId:0,

            topicSelectionId:this.state.newsActivity.topicSelectionId,
        };//这里不能传this.state.newsActivity，多余的参数会导致在修改任务的时候请求报400

        let isHaveTextReporter = false;//必须包含一个文字记者
        const interviewRole_Text = 1;//为1时为文字记者
        for(let i = 0 ; i < interviewJointers.length; i++){
            let jointer = interviewJointers[i];
            if(!jointer.interviewRole){
                message.error(jointer.jointerName+"请至少设置一项类别");
                return false;
            }
            params["reporterAccount"+i] = jointer.account;
            params["reporterRole"+i] = jointer.interviewRole;
            if(parseInt(jointer.interviewRole) === interviewRole_Text){
                isHaveTextReporter = true;
            }
            params["reporterIsManager"+i] = "0";//默认是0 都不是负责人
            params["difficulty"+i] = jointer.difficulty;
            params["properties"+i] = jointer.properties;
        }

        if(!isHaveTextReporter){
            message.error("请至少分派一个文字记者");
            return false;
        }


        params.reporterSize = interviewJointers.length;

        (()=>{
            publishNewActivity(params).then(res=>{
                // window.loading.hide();
                this.setState({
                    newsActivity:{
                        ...this.state.newsActivity,
                        ...params
                    },
                    // stepCurrent: this.state.stepCurrent + 1
                });
            })
        })();
        this.isLoadList = true;//记者分派完了就代表不管怎么样都会刷新列表
        return true;
    };

    saveActivityComplete(){
        this.setState({
            newsActivity:{},
            stepCurrent: 0
        });
        newActivityBaseInfoKey = uuid();
        plansToplatformKey = uuid();
        newsActivitySelectReporterKey = uuid();
        this.getFirstPageData();//刷新列表数据
        return true;
    }

    handleReset = () => {
        this.props.form.resetFields();
        this.state.startDate='';
        this.state.endDate='';
        this.state.searchValue='';
        this.state.selectValue='全部';
        this.state.activityUrl="/cm-sites-" + applicationName()+"/interview/all";
        this.getFirstPageData();
    };

    /**
     * 选择时间后触发搜索功能。
     * @param openFlag
     */
    onOpenChange(moment1,moment2) {
        // console.info("onOpenChange"+moment+dateString);
        //关闭窗口触发 搜索功能，
        // if (!openFlag){
        if (!moment1 || !moment2) {
            return;
        }
        let startDate=moment2[0];
        let endDate=moment2[1];
        // if (moment1 > moment2) {
        //     startDate = moment2;
        //     endDate = moment1;
        // } else {
        //     startDate = moment1;
        //     endDate = moment2;
        // }
        // let formDate = this.props.form.getFieldsValue(["range-picker"]);
        // if(formDate['range-picker']&&formDate['range-picker'].length>0){
        //     let startDate=formDate['range-picker'][0].format('YYYY-MM-DD');
        //     let endDate=formDate['range-picker'][1].format('YYYY-MM-DD');
        this.state.startDate = startDate;
        this.state.endDate = endDate;
        let searchValue = this.props.form.getFieldsValue(["searchValue"]);
        if (searchValue) {
            this.state.searchValue = searchValue['searchValue'];
        }
        this.getFirstPageData();
        // }
        // }
    }

    getSearchValeu(value){
        this.state.searchValue=value;
        this.getFirstPageData();
    }

    closeModel(){
        this.setState({
            stepVisible:false,
            stepCurrent: 0
        });
        if(this.isLoadList){
            this.getFirstPageData();
            this.isLoadList = false;
        }
    }

    handleNewsActivityViewTabs(newsActivity){
        let newsActivityViewTabs = [];
        let newsActivityViewTabPanels = [];
        let roleComponentMap = {
            type_1: {tab:{title:"任务稿件",footer:null},tabPanel:<NewsActivityWriteStory refreshParentMethod={()=>{this.setState({newsActivity,newsActivityViewActiveIndex:3})}} currentUser={this.props.currentUser} data={newsActivity}/>,push:false},
            type_2: {tab:{title:"任务图片",footer:null},tabPanel:<NewsActivityPicture currentUser={this.props.currentUser} data={newsActivity}/>,push:false},
            type_3: {tab:{title:"任务视频",footer:null},tabPanel:<NewsActivityVideo currentUser={this.props.currentUser} data={newsActivity}/>,push:false},
            type_4: {tab:{title:"美工附件",footer:null},tabPanel:<NewsActivityArtFile currentUser={this.props.currentUser} data={newsActivity}/>,push:false},
        };

        //先看看当前角色是不是主任，如果是主任的话，那就直接判断有没有人领取
        let isEditAuth = false;
        if(this.props.currentUser && this.props.currentUser.roleCodes){
            // isEditAuth = this.props.currentUser.roleCodes.indexOf(haveEditAuthRoleCode) !== -1;
            isEditAuth=permissionCheck("pms:newsActiviti:taskManage");
        }
        if(newsActivity && this.props.currentUser){
            //查看当前的记者有哪些角色
            if(newsActivity.interviewJointers){
                newsActivity.interviewJointers.map(jointer=>{
                    if(isEditAuth || (jointer.account === this.props.currentUser.account)){
                        //判断是否已经领取了
                        if(jointer.status !== 1 && !roleComponentMap["type_"+jointer.interviewRole].push){//已领取才显示
                            newsActivityViewTabs.push(roleComponentMap["type_"+jointer.interviewRole].tab);
                            newsActivityViewTabPanels.push(roleComponentMap["type_"+jointer.interviewRole].tabPanel);
                            roleComponentMap["type_"+jointer.interviewRole].push = true;
                        }
                    }
                });
            }
        }

        return {newsActivityViewTabs,newsActivityViewTabPanels};
    }

    render() {

        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let stepDataSource = [
            // {'title':'活动完成',img:'images/newsactivity/newactivity_complete.png', content:<NewsActivityComplete data={this.state.newsActivity} saveData={()=>{}}/>},
            {title:'基本信息',img:'images/newsactivity/newactivity_baseInfo.png',key:"jbxx",
            content:<NewActivityBaseInfo
                key={newActivityBaseInfoKey}
                sysConfig={this.props.sysConfig}
                data={this.state.newsActivity}
                wrappedComponentRef={(inst)=>this.activityBaseForm=inst}
                eventItemChange={(eventItem)=>{this.setState({newsActivity:{...this.state.newsActivity, eventItem}})}}
                leixingChange={(leixing)=>{this.setState({newsActivity:{...this.state.newsActivity, leixing}})}}
                sponsorChange={(sponsor)=>{this.setState({newsActivity:{...this.state.newsActivity, sponsor}})}}
                interviewDateChange={(interviewDate)=>{this.setState({newsActivity:{...this.state.newsActivity, interviewDate:(interviewDate?interviewDate.toDate():undefined)}})}}
                endDateChange={(endDate)=>{this.setState({newsActivity:{...this.state.newsActivity, endDate:(endDate?endDate.toDate():undefined)}})}}
                saveData={this.saveBaseInfo.bind(this)} />},
            {title:'拟发平台',img:'images/newsactivity/sendPlatform.png',key:"nfpt",
                content:<PlansToplatform ref={(inst)=>this.sendPlatformRef=inst}
                                         key={plansToplatformKey}
                                         newSecondSelectColor={newSecondSelectColor}
                                         data={this.state.newsActivity}
                                         saveData={this.saveToplatform.bind(this)}/>},
            {title:'选择记者',img:'images/newsactivity/chooseReporter.png',key:"xzjz",
                content:<NewsActivitySelectReporter
                                key={newsActivitySelectReporterKey}
                                onRef={(ref) => this.selectReporterRef = ref }
                                data={this.state.newsActivity} saveData={this.saveSelectReporter.bind(this)}/>},
            {title:'创建完成',img:'images/newsactivity/newactivity_complete.png',key:"hdwc",
                content:<NewsActivityComplete
                    type="新闻策划"
                    data={this.state.newsActivity}
                    saveData={this.saveActivityComplete.bind(this)}/>}];

        const { getFieldDecorator } = this.props.form;
        const rangeConfig = {
            rules: [{ type: 'array', required: true }],
        };


        // let isAddAuth = false;
        // if(this.props.currentUser && this.props.currentUser.roleCodes){
        //     isAddAuth = this.props.currentUser.roleCodes.indexOf(haveEditAuthRoleCode) !== -1;
        // }

        let height = document.body.clientHeight - HEADER_HEIGHT;//上部分70//
        return <div style={{padding:'5px 20px 20px 20px', height}}>
            <div ><NewsHead DataSource={this.state.activityCountData}/></div>
            <div className={"select_title"} style={{color:newSecondSelectColor}}>新闻策划</div>
            <div className={"newActiviti_status"}>
                <Form labelCol={{span: 5}} wrapperCol={{span: 12}}>
                    <div className={'form_item'}>
                            <Select
                                value={this.state.selectValue}
                                onChange={this.handleChange.bind(this)}
                            >
                                {this.state.newsActivityStatusData.map(item => (
                                    <Option key={item.key} value={item.key}>
                                        <span className={"status_item"}>{item.value}</span>
                                    </Option>
                                ))}
                            </Select>
                    </div>
                    <div className={'form_item_right'}>
                        <Button onClick={this.handleReset} type="primary" style={{backgroundColor:newSecondSelectColor,color: '#fefeff',borderColor:newSecondSelectColor}}>
                            重置筛选
                        </Button></div>
                    <div className={'form_item_right'}>
                        <span className={"new_activity_text"}>任务时间</span>
                        {getFieldDecorator('range-picker', rangeConfig)(<RangePicker  onChange={this.onOpenChange.bind(this)} showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }} />)}</div>
                    <div className={'form_item_right'}>
                        {getFieldDecorator('searchValue', rangeConfig)( <Search
                            placeholder="输入搜索内容"
                            onSearch={value => {this.getSearchValeu(value)}}
                            style={{ width: 200}}
                        />)}
                    </div>
                </Form>
            </div>
            {
                permissionCheck("pms:newsActiviti:add")?<div style={{marginTop:'10px'}}><Button type="dashed"  style={{width:'100%',height:'50px'}} onClick={this.addNewActivity.bind(this)}>
                    <img src={'images/newsactivity/news_activity_add.png'} />
                    <span style={{marginLeft:'10px',color:'#a4adc8',fontSize:'16px',fontFamily: 'MicrosoftYaHei'}}>添加任务</span>
                </Button>
                <style>
                        {`
            .ant-btn-dashed:hover{
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                </div>:""
            }
            <div className={"newactivity_table"}>
                <Table  showHeader={false} columns={this.state.columns}  dataSource={this.state.newActivityTableData.data}
                        rowKey={record=>record.id}
                        pagination={{'total':this.state.newActivityTableData.count,'current':this.state.currentPage}} scroll={{y: permissionCheck("pms:newsActiviti:add") ? height-425 : height-375 }}
                        onChange={this.onTableChange.bind(this)}/>
            </div>
            <StepPopupBox title={this.state.taskStatus===1?"修改任务":"新增任务"}
                          current={this.state.stepCurrent}
                          onChange={(stepCurrent)=>{
                              this.setState({
                                  stepCurrent
                              })
                          }}
                          getTaskStatus={()=>this.getTaskStatus()}
                          closeModel={this.closeModel.bind(this)}
                          visible={this.state.stepVisible} stepDataSource={stepDataSource}/>
            <TabModal visible={this.state.newsActivityViewVisible}
                      onCancel={()=>{
                          this.setState({
                              newsActivityViewVisible: false
                          })
                      }}
                      activeIndex={this.state.newsActivityViewActiveIndex}
                      width={1100}
                      tabs={[{
                          title:"基本信息",
                          footer:<div className={"ant-modal-footer"}>
                              <NewsActivityBaseInfoFooter
                                                          currentUser={this.props.currentUser}
                                                          data={this.state.newsActivity}
                                                          takeTaskAfter={()=>{
                                                              let {newsActivityViewTabs,newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(this.state.newsActivity);
                                                              this.setState({newsActivityViewTabs,newsActivityViewTabPanels})
                                                          }}
                                                          update={(id)=>this.updateDataById(id)}
                                                          cencel={()=>{
                                                              this.setState({
                                                                  newsActivityViewVisible: false
                                                              })
                                                          }}
                                                          getData= {() => this.getFirstPageData()}
                              />
                          </div>
                      },{
                          title:"拟发平台",
                          footer:null
                      },{
                          title:"分派记者",
                          footer:null
                      },...this.state.newsActivityViewTabs]}
                      tabPanels={[<NewsActivityBaseInfo data={this.state.newsActivity} />,
                          <NewsActivityPublishPlatform data={this.state.newsActivity} />,
                          <NewsActivityReporter data={this.state.newsActivity}/>,
                          ...this.state.newsActivityViewTabPanels]} />
        </div>
    }
    getTaskStatus(){
        this.setState({
            taskStatus:0
        })
    }
}

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig : state.systemReducer.config
    }
}

const NewsActivityIndexForm = Form.create({ name: 'time_related_controls' })(connect(mapStateToProps,null,null, { forwardRef: true })(NewsActivityIndex));
export  default NewsActivityIndexForm;

/**
 * 任务头部组件
 * @param props
 * @returns {*}
 * @constructor
 */
function NewsHead(props) {
    return  <div className={"newhead_background"} style={{backgroundImage:'url(images/newsactivity/newactivity_background.png)'}}>
        <Row justify="space-around">
        {props.DataSource.map((item,index)=>{
        return <Col span={4} key={uuid()} ><div   className={"newsHead_task_card"}>
            <div style={{fontSize:'14px',color:'#ffffff',textAlign:'center'}}>{item.title}</div>
            <div style={{fontSize:'18px',fontWeight:'600',color:'#ffffff',textAlign:'center'}}>{item.count}个任务</div>
        </div></Col>
    })}
            <Col span={4}>
        <div className={"newsHead_task_card"}>
            <img width={'60'} src={'./images/newsactivity/news_activity_task.png'}/>
        </div></Col>
        </Row>
    </div>
}